import { css } from '@styles/theme'

export const migrationVideoStyles = {
	background: css({
		backgroundColor: '$neutral10',
		width: '100%',
		height: '100vh',
		display: 'flex',
		justifyContent: 'center',
		flexDirection: 'row',
		p: {
			color: '$primary',
		},
	}),
	container: css({
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		width: '100%',
		padding: '24px',

		a: {
			textDecoration: 'none',
			textDecorationline: 'none',
		},

		'@lg': {
			width: '70%',
			maxWidth: '1150px',
		},

		'& svg': {
			marginBottom: '20px',
		},

		'& .titles': {
			display: 'flex',
			flexDirection: 'column',
			gap: '16px',
			width: '100%',
			maxWidth: '432px',
			marginBottom: '$6',

			h4: {
				_font: 'normal',
				fontSize: '$xxxl',
				lineHeight: '19px',
				color: '$neutral100',
			},

			p: {
				_font: 'normal',
				fontSize: '$xxl',
				color: '$neutral90',
			},
		},
	}),

	videoResponsive: css({
		overflow: 'hidde',
		paddingBottom: '56.25%',
		position: 'relative',
		height: '0',
		width: '100%',

		iframe: {
			left: '0',
			top: '0',
			height: '100%',
			width: '100%',
			position: 'absolute',
			borderRadius: '12px',
			border: 'none',
		},
	}),

	linkStyle: css({
		display: 'flex',
		justifyContent: 'center',
		marginTop: '16px',
		width: '100%',
		height: '48px',
	}),
}
